import { useRef, useState } from "react";
import styles from "./FormularioAprovacao.module.css";

const opcoes = [
  { valor: true, texto: "Aprovado", classe: "approved" },
  { valor: false, texto: "Reprovado", classe: "rejected" },
  { valor: null, texto: "Em branco", classe: "blank" },
];

export default function FormularioAprovacao({ formularioId, aprovado, onChange }) {
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const emAndamento = useRef(false);
  const valorAtual = aprovado == null ? null : aprovado === true || aprovado === 1;

  const salvar = async (valor) => {
    if (emAndamento.current) return;
    emAndamento.current = true;
    setSalvando(true);
    setErro("");
    try {
      await onChange(valor);
    } catch {
      setErro("Não foi possível salvar o resultado. Tente novamente.");
    } finally {
      emAndamento.current = false;
      setSalvando(false);
    }
  };

  return (
    <div className={styles.control} role="group" aria-label={`Resultado do formulário ${formularioId}`} aria-busy={salvando}>
      <span className={styles.label}>Resultado</span>
      <div className={styles.options}>
        {opcoes.map(({ valor, texto, classe }) => (
          <button
            key={texto}
            type="button"
            className={`${styles.option} ${valorAtual === valor ? styles[classe] : ""}`}
            aria-pressed={valorAtual === valor}
            disabled={salvando || valorAtual === valor}
            onClick={() => salvar(valor)}
          >
            {texto}
          </button>
        ))}
      </div>
      {salvando && <span role="status" className={styles.message}>Salvando…</span>}
      {erro && <span role="alert" className={styles.error}>{erro}</span>}
    </div>
  );
}
